import React from 'react';
import styled from 'styled-components';
import { Controller, useFormContext } from 'react-hook-form';
import RadioGroup, {
  RadioGroupProps,
} from 'up-ops-web-shared-components/lib/components/radio/radio-group';

import { FormComponentProps } from 'types/components';

type FormRadioGroupProps = FormComponentProps & RadioGroupProps;

const FormRadioGroup = ({
  children,
  defaultValue,
  name,
  rules,
  ...props
}: FormRadioGroupProps) => {
  const { control, formState } = useFormContext();

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field, fieldState }) => {
        const { onBlur, onChange } = field;
        const { error, invalid } = fieldState;
        return (
          <RadioGroup
            disabled={formState.isSubmitting}
            error={invalid}
            hint={error?.message}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            {...props}
          >
            {children}
          </RadioGroup>
        );
      }}
      rules={rules}
    />
  );
};

export const TwoAnswerRadioGroup = styled(FormRadioGroup)`
  .MuiFormGroup-root {
    flex-direction: row;
  }

  .MuiFormGroup-root > * + * {
    margin-left: 4rem;
  }
`;

export default FormRadioGroup;
